








import { Vue, Component, Prop } from "vue-property-decorator";
import Item from "@/components/grace/item.vue";
import { GraceItem } from "@/interface/grace";
@Component({
  components: {
    Item
  }
})
export default class GraceList extends Vue {
  @Prop() data!: Array<GraceItem>;
}
